import { theme } from '../../styles/index';
import { Colors } from '../../utils';
import { Box } from '../Layout';

type WideBoxProps = {
  backgroundColor?: Colors;
  marginTop?: number;
  marginBottom?: number;
  children: React.ReactNode;
  borderColor?: Colors;
};

/** A box that is wider than its parent. The text still aligns with the parent, but tha background color stretches out to the sides  */
export const WideBox = ({
  backgroundColor = 'black05',
  marginTop,
  marginBottom,
  children,
  borderColor,
}: WideBoxProps) => (
  <Box
    backgroundColor={backgroundColor}
    paddingTop={[20, 30, 30]}
    paddingBottom={[20, 30, 30]}
    marginRight={[-20, -40, -40]}
    marginTop={marginTop}
    marginBottom={marginBottom}
    marginLeft={[-20, -40, -40]}
    paddingRight={[20, 40, 40]}
    paddingLeft={[20, 40, 40]}
    position="relative"
    border={borderColor ? `1px solid ${theme.colors[borderColor]}` : 'none'}
    style={{ borderBottom: borderColor ? `2px solid ${theme.colors[borderColor]}` : 'none' }}
  >
    {children}
  </Box>
);
